import {
	styled,
} from '@mui/material'

import {
	HStack,
} from '@/shared/components/stack'

export const Logo = styled(HStack)`
	max-width: 100px;
	
	img {
		max-width: 100%;
	}
`
